import * as React from 'react';
import s from './InvoiceActions.scss';
import Print from 'wix-ui-icons-common/Print';
import { TFunction, WithTranslation, withTranslation } from 'react-i18next';
import { Button, Notification } from '@wix/design-system';
import {
  PdfDownloader,
  xsrfHeaderKey,
  getXsrfCookie,
} from './PdfDownloader/PdfDownloader';
import { useState } from 'react';

export interface InvoiceActionsProps extends WithTranslation {
  withPay: boolean;
  pdfUrl: string;
  token: string;
  print(): void;
  payUrl: string;
  setup?: { hidePdfDownloader?: boolean; mobileInvoiceViewV2Enabled?: boolean };
  version: number;
  onDownloadPDF(): void;
  onPayForm?(): void;
  newMobileViewEnabled: boolean;
  isPremium: boolean;
}

const PayForm = ({
  token,
  t,
  url,
  version,
  onPayForm,
}: {
  token: string;
  t: TFunction;
  url: string;
  version: number;
  onPayForm: () => void;
}) => (
  <form method="POST" action={url} onSubmit={onPayForm}>
    <Button className="pay-button" dataHook="pay-button" type="submit">
      {t('translation:invoice.actions.pay')}
    </Button>
    <input type="hidden" name="token" value={token} />
    <input type="hidden" name="version" value={version} />
    <input type="hidden" name={xsrfHeaderKey} value={getXsrfCookie()} />
  </form>
);

const InvoiceActionsComp = ({
  withPay,
  pdfUrl,
  payUrl,
  token,
  print,
  setup = {},
  version,
  onDownloadPDF,
  t,
  onPayForm = () => {},
  newMobileViewEnabled,
  isPremium,
}: InvoiceActionsProps) => {
  const [showError, setShowError] = useState(false);
  const withUserActions = withPay || !setup.hidePdfDownloader;

  return (
    <>
      <Notification
        autoHideTimeout={4000}
        theme="error"
        show={showError}
        type="sticky"
        onClose={() => setShowError(false)}
      >
        <Notification.TextLabel>
          {t('translation:invoice.actions.save-pdf.error')}
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
      <div
        className={`${s.actions} ${withUserActions ? s.withUserActions : ''}`}
      >
        <div className={s.exportActions}>
          <Button theme="icon-white" dataHook="print-button" onClick={print}>
            <Print />
          </Button>
          {!setup.hidePdfDownloader && (
            <PdfDownloader
              text={t('translation:invoice.actions.save-pdf')}
              token={token}
              pdfUrl={pdfUrl}
              onDownloadPDF={onDownloadPDF}
              onDownloadFail={() => {
                setShowError(true);
              }}
            />
          )}
        </div>

        <div className={s.userActions}>
          {!!withPay && isPremium && (
            <PayForm
              t={t}
              url={payUrl}
              token={token}
              version={version}
              onPayForm={onPayForm}
            />
          )}
          {!setup.hidePdfDownloader && newMobileViewEnabled && (
            <PdfDownloader
              text={
                !!withPay || !setup?.mobileInvoiceViewV2Enabled
                  ? ''
                  : t('translation:invoice.actions.save-pdf')
              }
              token={token}
              pdfUrl={pdfUrl}
              onDownloadPDF={onDownloadPDF}
              onDownloadFail={() => {
                setShowError(true);
              }}
              newMobileViewEnabled
            />
          )}
        </div>
      </div>
    </>
  );
};
const InvoiceActions = withTranslation()(InvoiceActionsComp);
export { InvoiceActions };
